enum NameProjectTypes {
  "Factory" = "Projeto de fábrica",
}

export default NameProjectTypes;
